import React from 'react';
import { motion } from 'framer-motion';
import { Users, Globe, Award } from 'lucide-react';

const stats = [
  { icon: Users, value: "1,400+", label: "Lives Impacted", color: "text-primary" },
  { icon: Globe, value: "2", label: "Countries Served", color: "text-secondary" },
  { icon: Users, value: "256+", label: "Volunteers", color: "text-accent" },
  { icon: Award, value: "22", label: "Community Awards", color: "text-primary" }
];

export default function Impact() {
  return (
    <section id="impact" className="py-16 sm:py-20 bg-muted/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">Our Impact</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground">
            Making a <span className="text-primary italic">Difference</span>
          </h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto text-lg">
            ROJCD is committed to delivering sustainable economic growth and poverty reduction
            within the local communities we serve.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="bg-card rounded-2xl p-6 sm:p-8 text-center shadow-sm border border-border"
            >
              <stat.icon className={`w-8 h-8 mx-auto mb-4 ${stat.color}`} />
              <p className={`text-3xl sm:text-4xl font-heading font-bold ${stat.color}`}>
                {stat.value}
              </p>
              <p className="text-muted-foreground text-sm mt-2">{stat.label}</p>
            </motion.div>
          ))}
        </div>

        {/* Quote */}
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 max-w-3xl mx-auto text-center"
        >
          <p className="text-xl sm:text-2xl font-heading italic text-foreground leading-relaxed">
            "Powerful and sustained change requires constant communication, not only throughout
            the rollout but after the major elements of the plan are in place."
          </p>
          <cite className="block mt-4 text-muted-foreground text-sm not-italic">
            — DeAnne Aguirre
          </cite>
        </motion.blockquote>
      </div>
    </section>
  );
}